export default class OrganisationUserType {
    static Member: string = 'Member';
    static Admin: string = 'Admin';
}